import {
  ICampaignSaveResponseDTO,
  ICampaignFiltersDto,
  ICampaignListDTO,
  ICampaignDetailsDTO,
  IAggregateReportDTO,
} from "../../interfaces/dto/campaign.dto";

export enum CampaignActions {
  CAMPAIGN_GET_LIST = "CAMPAIGN_GET_LIST",
  CAMPAIGN_GET_LIST_SUCCESS = "CAMPAIGN_GET_LIST_SUCCESS",
  CAMPAIGN_GET_LIST_FAILURE = "CAMPAIGN_GET_LIST_FAILURE",
  CAMPAIGN_GET_LIST_FILTERS = "CAMPAIGN_GET_LIST_FILTERS",
  CAMPAIGN_SAVE = "CAMPAIGN_SAVE",
  CAMPAIGN_SAVE_SUCCESS = "CAMPAIGN_SAVE_SUCCESS",
  CAMPAIGN_SAVE_FAILURE = "CAMPAIGN_SAVE_FAILURE",
  CAMPAIGN_UPDATE = "CAMPAIGN_UPDATE",
  CAMPAIGN_UPDATE_SUCCESS = "CAMPAIGN_UPDATE_SUCCESS",
  CAMPAIGN_UPDATE_FAILURE = "CAMPAIGN_UPDATE_FAILURE",
  CAMPAIGN_GET_DETAILS = "CAMPAIGN_GET_DETAILS",
  CAMPAIGN_GET_DETAILS_SUCCESS = "CAMPAIGN_GET_DETAILS_SUCCESS",
  CAMPAIGN_GET_DETAILS_FAILURE = "CAMPAIGN_GET_DETAILS_FAILURE",
  CAMPAIGN_UPDATE_STATUS = "CAMPAIGN_UPDATE_STATUS",
  CAMPAIGN_UPDATE_STATUS_FAILURE = "CAMPAIGN_UPDATE_STATUS_FAILURE",
  CAMPAIGN_UPDATE_STATUS_SUCCESS = "CAMPAIGN_UPDATE_STATUS_SUCCESS",
  GET_TRACKIER = "GET_TRACKIER",
  GET_TRACKIER_SUCCESS = "GET_TRACKIER_SUCCESS",
  GET_TRACKIER_FAILURE = "GET_TRACKIER_FAILURE",
  SAVE_TRACKIER = "SAVE_TRACKIER",
  SAVE_TRACKIER_SUCCESS = "SAVE_TRACKIER_SUCCESS",
  SAVE_TRACKIER_FAILURE = "SAVE_TRACKIER_FAILURE",
  GET_AGGREGATE_REPORT = "GET_AGGREGATE_REPORT",
  GET_AGGREGATE_REPORT_SUCCESS = "GET_AGGREGATE_REPORT_SUCCESS",
  GET_AGGREGATE_REPORT_FAILURE = "GET_AGGREGATE_REPORT_FAILURE",
}

interface IGetAggregateReportAction {
  type: CampaignActions.GET_AGGREGATE_REPORT;
}

export const getAggregateReportAction = (): IGetAggregateReportAction => ({
  type: CampaignActions.GET_AGGREGATE_REPORT,
});

interface IGetAggregateReportSuccessAction {
  type: CampaignActions.GET_AGGREGATE_REPORT_SUCCESS;
  payload: IAggregateReportDTO;
}

export const getAggregateReportSuccessAction = (
  payload: IAggregateReportDTO,
): IGetAggregateReportSuccessAction => ({
  type: CampaignActions.GET_AGGREGATE_REPORT_SUCCESS,
  payload,
});

interface IGetAggregateReportFailureAction {
  type: CampaignActions.GET_AGGREGATE_REPORT_FAILURE;
  payload: { error: string };
}

export const getAggregateReportFailureAction = (
  error: string,
): IGetAggregateReportFailureAction => ({
  type: CampaignActions.GET_AGGREGATE_REPORT_FAILURE,
  payload: { error },
});

interface ISaveTrackierAction {
  type: CampaignActions.SAVE_TRACKIER;
}

export const saveTrackierAction = (): ISaveTrackierAction => ({
  type: CampaignActions.SAVE_TRACKIER,
});

interface ISaveTrackierSuccessAction {
  type: CampaignActions.SAVE_TRACKIER_SUCCESS;
  payload: string;
}

export const saveTrackierSuccessAction = (
  payload: string,
): ISaveTrackierSuccessAction => ({
  type: CampaignActions.SAVE_TRACKIER_SUCCESS,
  payload,
});

interface ISaveTrackierFailureAction {
  type: CampaignActions.SAVE_TRACKIER_FAILURE;
  payload: { error: string };
}

export const saveTrackierFailureAction = (
  error: string,
): ISaveTrackierFailureAction => ({
  type: CampaignActions.SAVE_TRACKIER_FAILURE,
  payload: { error },
});

interface IGetTrackierAction {
  type: CampaignActions.GET_TRACKIER;
}

export const getTrackierAction = (): IGetTrackierAction => ({
  type: CampaignActions.GET_TRACKIER,
});

interface IGetTrackierSuccessAction {
  type: CampaignActions.GET_TRACKIER_SUCCESS;
  payload: Array<string>;
}

export const getTrackierSuccessAction = (
  payload: Array<string>,
): IGetTrackierSuccessAction => ({
  type: CampaignActions.GET_TRACKIER_SUCCESS,
  payload,
});

interface IGetTrackierFailureAction {
  type: CampaignActions.GET_TRACKIER_FAILURE;
  payload: { error: string };
}

export const getTrackierFailureAction = (
  error: string,
): IGetTrackierFailureAction => ({
  type: CampaignActions.GET_TRACKIER_FAILURE,
  payload: { error },
});

interface ICampaignUpdateStatusAction {
  type: CampaignActions.CAMPAIGN_UPDATE_STATUS;
}

export const updateCampaignStatusAction = (): ICampaignUpdateStatusAction => ({
  type: CampaignActions.CAMPAIGN_UPDATE_STATUS,
});

interface ICampaignUpdateStatusSuccessAction {
  type: CampaignActions.CAMPAIGN_UPDATE_STATUS_SUCCESS;
  payload: object;
}

export const updateCampaignStatusSuccessAction = (
  payload: object,
): ICampaignUpdateStatusSuccessAction => ({
  type: CampaignActions.CAMPAIGN_UPDATE_STATUS_SUCCESS,
  payload,
});

interface ICampaignUpdateStatusFailureAction {
  type: CampaignActions.CAMPAIGN_UPDATE_STATUS_FAILURE;
  payload: { error: string };
}

export const updateCampaignStatusFailureAction = (
  error: string,
): ICampaignUpdateStatusFailureAction => ({
  type: CampaignActions.CAMPAIGN_UPDATE_STATUS_FAILURE,
  payload: { error },
});

interface ICampaignUpdateAction {
  type: CampaignActions.CAMPAIGN_UPDATE;
}

export const updateCampaignAction = (): ICampaignUpdateAction => ({
  type: CampaignActions.CAMPAIGN_UPDATE,
});

export interface ICampaignUpdateSuccessAction {
  type: CampaignActions.CAMPAIGN_UPDATE_SUCCESS;
  payload: ICampaignSaveResponseDTO;
}

export const updateCampaignSuccessAction = (
  payload: ICampaignSaveResponseDTO,
): ICampaignUpdateSuccessAction => ({
  type: CampaignActions.CAMPAIGN_UPDATE_SUCCESS,
  payload,
});

export interface ICampaignUpdateFailureAction {
  type: CampaignActions.CAMPAIGN_UPDATE_FAILURE;
  payload: { error: string };
}

export const updateCampaignFailureAction = (
  error: string,
): ICampaignUpdateFailureAction => ({
  type: CampaignActions.CAMPAIGN_UPDATE_FAILURE,
  payload: { error },
});

interface ICampaignGetDetailsAction {
  type: CampaignActions.CAMPAIGN_GET_DETAILS;
}

export const getCampaignDetailsAction = (): ICampaignGetDetailsAction => ({
  type: CampaignActions.CAMPAIGN_GET_DETAILS,
});

interface ICampaignGetDetailsSuccessAction {
  type: CampaignActions.CAMPAIGN_GET_DETAILS_SUCCESS;
  payload: ICampaignDetailsDTO;
}

export const getCampaignDetailsSuccessAction = (
  payload: ICampaignDetailsDTO,
): ICampaignGetDetailsSuccessAction => ({
  type: CampaignActions.CAMPAIGN_GET_DETAILS_SUCCESS,
  payload,
});

interface ICampaignGetDetailsFailureAction {
  type: CampaignActions.CAMPAIGN_GET_DETAILS_FAILURE;
  payload: { error: string };
}

export const getCampaignDetailsFailureAction = (
  error: string,
): ICampaignGetDetailsFailureAction => ({
  type: CampaignActions.CAMPAIGN_GET_DETAILS_FAILURE,
  payload: { error },
});

interface ICampaignSaveAction {
  type: CampaignActions.CAMPAIGN_SAVE;
}

export const saveCampaignAction = (): ICampaignSaveAction => ({
  type: CampaignActions.CAMPAIGN_SAVE,
});

export interface ICampaignSaveSuccessAction {
  type: CampaignActions.CAMPAIGN_SAVE_SUCCESS;
  payload: ICampaignSaveResponseDTO;
}

export const saveCampaignSuccessAction = (
  payload: ICampaignSaveResponseDTO,
): ICampaignSaveSuccessAction => ({
  type: CampaignActions.CAMPAIGN_SAVE_SUCCESS,
  payload,
});

export interface ICampaignSaveFailureAction {
  type: CampaignActions.CAMPAIGN_SAVE_FAILURE;
  payload: { error: string };
}

export const saveCampaignFailureAction = (
  error: string,
): ICampaignSaveFailureAction => ({
  type: CampaignActions.CAMPAIGN_SAVE_FAILURE,
  payload: { error },
});

interface ICampaignListFiltersAction {
  type: CampaignActions.CAMPAIGN_GET_LIST_FILTERS;
  payload: ICampaignFiltersDto;
}

export const setCampaignListFiltersAction = (
  filters: ICampaignFiltersDto,
): ICampaignListFiltersAction => ({
  type: CampaignActions.CAMPAIGN_GET_LIST_FILTERS,
  payload: filters,
});

interface IGetCampaignListAction {
  type: CampaignActions.CAMPAIGN_GET_LIST;
}

export const getCampaignListAction = (): IGetCampaignListAction => ({
  type: CampaignActions.CAMPAIGN_GET_LIST,
});

export interface IGetCampaignListSuccessAction {
  type: CampaignActions.CAMPAIGN_GET_LIST_SUCCESS;
  payload: ICampaignListDTO;
}

export const getCampaignListSuccessAction = (
  payload: ICampaignListDTO,
): IGetCampaignListSuccessAction => ({
  type: CampaignActions.CAMPAIGN_GET_LIST_SUCCESS,
  payload,
});

export interface IGetCampaignListFailureAction {
  type: CampaignActions.CAMPAIGN_GET_LIST_FAILURE;
  payload: { error: string };
}

export const getCampaignListFailureAction = (
  error: string,
): IGetCampaignListFailureAction => ({
  type: CampaignActions.CAMPAIGN_GET_LIST_FAILURE,
  payload: { error },
});

export type ICampaignActions =
  | IGetCampaignListAction
  | IGetCampaignListFailureAction
  | IGetCampaignListSuccessAction
  | ICampaignListFiltersAction
  | ICampaignSaveAction
  | ICampaignSaveFailureAction
  | ICampaignSaveSuccessAction
  | ICampaignGetDetailsAction
  | ICampaignGetDetailsFailureAction
  | ICampaignGetDetailsSuccessAction
  | ICampaignUpdateAction
  | ICampaignUpdateFailureAction
  | ICampaignUpdateSuccessAction
  | ICampaignUpdateStatusAction
  | ICampaignUpdateStatusFailureAction
  | ICampaignUpdateStatusSuccessAction
  | IGetTrackierAction
  | IGetTrackierFailureAction
  | IGetTrackierSuccessAction
  | ISaveTrackierAction
  | ISaveTrackierFailureAction
  | ISaveTrackierSuccessAction
  | IGetAggregateReportAction
  | IGetAggregateReportFailureAction
  | IGetAggregateReportSuccessAction;
